import { BaseModel } from "./base/base.model";


export class AppSmtp extends BaseModel {
    smtpServer1!: string;
    outServer?: string;
    outServerPort?: number;
    tlsSsl?: boolean;
    user?: string;
    password?: string;
    company?: string;
    enable?: boolean;
    modifiedBy: string;
}
